var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-bar"},_vm._l((_vm.menus),function(item){return _c('div',{key:item.tabId,staticClass:"nav-bar-item",class:{ active: _vm.currentRoutePath == item.redirectUrl },attrs:{"data-io-click":"tracker"},on:{"click":function($event){return _vm.handlePath(item.redirectUrl)}}},[_vm._v(" "+_vm._s(item.tabName)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }